export const HeaderSection = {
  partners: 'Les partenaires',
  accessories: 'Accessoires',
  stages: 'Étapes',
  order: 'Commande',
};
export const description =
  "Une maison intelligente est votre assistant personnel qui se soucie de votre confort et de votre convivialité. Le système peut être installé partout où vous vivez ou travaillez. Pour le contrôler, il suffit d'une tablette, d'un téléphone ou d'un ordinateur. Grâce à son protocole sécurisé unique et à son application mobile, le complexe vous garantit un contrôle total de vos locaux à tout moment. Pour allumer la lumière, ouvrir les rideaux ou éteindre le climatiseur, il n'est pas nécessaire de se lever du canapé.";
